import { Injectable } from '@angular/core';

import { RestApiService } from 'src/app/services/rest-api.service';
import { LanguageModel } from '../models/language.model';
import { map } from 'rxjs/operators';
import { AuthToken } from './auth.service';
import { UserProfileModel } from '../models/user-profile.model';
import { IMilkBottle, MilkBottleModel } from '../models/milk.model';
import { lastValueFrom } from 'rxjs';
import { IPatient, PatientModel } from '../models/patient.model';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class KioskService {
	constructor(private http: RestApiService) {}

	getLanguages(): Promise<LanguageModel[]> {
		const url = '/kiosk/kiosk-start';

		return this.http
			.get(url, null)
			.pipe(map((res: { languages: LanguageModel[] }) => res.languages))
			.toPromise();
	}

	getKioskSystemUserToken(): Promise<AuthToken> {
		const url = '/kiosk/kiosk-system-token';

		return this.http
			.get(url, null)
			.pipe(map((res: { token: string }) => res))
			.toPromise();
	}

	getKioskSystemUserProfile(selectedPrinterId: string): Promise<UserProfileModel> {
		const url = '/kiosk/kiosk-system-profile';
		const params = {
			selectedPrinterId
		};
		return this.http
			.get(url, params)
			.pipe(map((res: UserProfileModel) => res))
			.toPromise();
	}

	async getKioskPatient(params: string) {
		// artificial delay
		await new Promise((resolve) =>
			setTimeout(resolve, environment.settings.apiDelay)
		);

		const url = `/kiosk/getpatients${params}`;
		return lastValueFrom(
			this.http
				.get(url)
				.pipe(map((res: IPatient) => new PatientModel(res)))
		);
	}

	async getKioskPatientDetailsByMilkBottle(
		milkBottle: MilkBottleModel
	): Promise<PatientModel[]> {
		if (!milkBottle) {
			return [];
		}

		return await Promise.all(
			milkBottle.patients.map(
				async (patient) => await this.getKioskPatient(`?mrn=${patient.mrn}`)
			)
		);
	}

	createNewMilkBottle(payload: {
		numberOfBottles: number;
		mothersId: string;
		mrn: string;
	}): Promise<MilkBottleModel[]> {
		const url = "/kiosk/new-labels";

		return lastValueFrom(
			this.http
				.post(url, payload)
				.pipe(
					map((res: IMilkBottle[]) =>
						res.map((m) => new MilkBottleModel(m))
					)
				)
		);
	}
}
